import { useState, useRef, useEffect } from 'react';
import useAuthStore from '../../../store/Auth';
import styles from './CreditIndicator.module.css';
import { Link } from 'react-router-dom';

const CreditIndicator = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { creditMessage } = useAuthStore();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative flex items-center h-[20px]" ref={dropdownRef}>
      {/* Trigger Element */}
      <div
        onClick={handleToggle}
        className={`px-2 py-[2px] border-0.5 border-[#E58484] rounded h-full flex items-center gap-1 justify-center cursor-pointer hover:opacity-60 transition-colors ${isOpen ? 'opacity-60' : 'opacity-100'}`}
      >
        <div className="flex items-center gap-1 py-[2px] h-full">
          <p className="text-[12px] font-bold text-[#E58484]">credit</p>
        </div>
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.12924 2.43766L5.65424 1.0085C5.25007 0.775163 4.75007 0.775163 4.34174 1.0085L1.8709 2.43766C1.46674 2.671 1.21674 3.10433 1.21674 3.57516V6.42516C1.21674 6.89183 1.46674 7.32516 1.8709 7.56266L4.3459 8.99183C4.75007 9.22516 5.25007 9.22516 5.6584 8.99183L8.1334 7.56266C8.53757 7.32933 8.78757 6.896 8.78757 6.42516V3.57516C8.7834 3.10433 8.5334 2.67516 8.12924 2.43766ZM4.68757 3.22933C4.68757 3.0585 4.82924 2.91683 5.00007 2.91683C5.1709 2.91683 5.31257 3.0585 5.31257 3.22933V5.41683C5.31257 5.58766 5.1709 5.72933 5.00007 5.72933C4.82924 5.72933 4.68757 5.58766 4.68757 5.41683V3.22933ZM5.3834 6.92933C5.36257 6.97933 5.3334 7.02516 5.2959 7.06683C5.21674 7.146 5.11257 7.18766 5.00007 7.18766C4.9459 7.18766 4.89174 7.17516 4.84174 7.15433C4.78757 7.1335 4.7459 7.10433 4.70424 7.06683C4.66674 7.02516 4.63757 6.97933 4.61257 6.92933C4.59174 6.87933 4.5834 6.82516 4.5834 6.771C4.5834 6.66266 4.62507 6.55433 4.70424 6.47516C4.7459 6.43766 4.78757 6.4085 4.84174 6.38766C4.9959 6.321 5.17924 6.3585 5.2959 6.47516C5.3334 6.51683 5.36257 6.5585 5.3834 6.61266C5.40424 6.66266 5.41674 6.71683 5.41674 6.771C5.41674 6.82516 5.40424 6.87933 5.3834 6.92933Z"
            fill="#E58484"
          />
        </svg>
      </div>

      {/* Dropdown Content */}
      {isOpen && (
        <div className="absolute top-full right-0 mt-1 w-[400px] bg-black-1 border-0.5 border-gray-200/20 rounded-md shadow-lg z-50 animate-in fade-in-0 slide-in-from-top-1 duration-200">
          <div className="px-4 py-4">
            <div className="flex items-start gap-2 mb-2">
              <h3 className="text-sm font-normal text-white-2">
                It looks like your OpenAI API quota has been exceeded or you
                have run out of credits. To continue using Crafter, please visit
                your OpenAI billing dashboard to add more credits or contact
                support@usecrafter.com.
              </h3>
            </div>

            <div className="mt-3 pt-2 border-t-0.5 border-gray-100/20">
              <Link
                to={
                  'https://platform.openai.com/settings/organization/billing/overview'
                }
                target="_blank"
                className="text-xs text-[#E58484] hover:text-[#d16b6b] font-medium w-fit flex ml-auto"
              >
                Purchase more credits
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreditIndicator;
